export const IN_PROGRESS_ASSISTANCES = 'myassistances'
export const LAST_GENERATED_REPORTS = 'lastGeneratedReport'

export const persistAssistances = (assistances) => {
  localStorage.setItem(IN_PROGRESS_ASSISTANCES, JSON.stringify(assistances))
}

export const persistReport = (report) => {
  localStorage.setItem(LAST_GENERATED_REPORTS, JSON.stringify(report))
}

export const loadAssitances = () => {
  const data = localStorage.getItem(IN_PROGRESS_ASSISTANCES)
  try {
    return JSON.parse(data)
  } catch {
    return []
  }
}

export const loadAssistanceReports = () => {
  const data = localStorage.getItem(LAST_GENERATED_REPORTS)
  try {
    return JSON.parse(data)
  } catch {
    return {}
  }
}